import Vue from 'vue';
import FormControl from 'components/form/validator/controls/FormControl';

/**
 * Vue.js mixin for components that want to act like a form control
 */
export default {
    beforeCreate() {
        // Create a new form form control for this components
        this.$formCtrl = new FormControl(this);
        // Ensure that any form or field state changes trigger an update
        Vue.util.defineReactive(this.$formCtrl, 'state', this.$formCtrl.state);
    },
    destroyed() {
        // Unbind all events
        this.$formCtrl.remove();
    },
    computed: {
        // Form for $form.$valid etc as required, be careful using $form.fieldname.$valid as field are not often loaded
        // by the time the view renders and you get object not found, better to use helper methods below
        $form() {
            return this.$formCtrl.state;
        },
    },
    methods: {
        /**
         * Is the form or a field valid
         * @param {string} [field] optional field, else if all fields are valid
         * @return {boolean|null}
         */
        $valid(field) {
            return this.$formCtrl.determine('$valid', field);
        },

        /**
         * Is the form or a field invalid
         *
         * @param {string} [field] optional field, else if all fields are invalid
         * @return {boolean|null}
         */
        $invalid(field) {
            return this.$formCtrl.determine('$invalid', field);
        },

        /**
         * Is the form or a field dirty
         * @param {string} [field] optional field, else if all fields are dirty
         * @return {boolean|null}
         */
        $dirty(field) {
            return this.$formCtrl.determine('$dirty', field);
        },

        /**
         * Is the form or a field clean
         * @param {string} [field] optional field, else if all fields are clean
         * @return {boolean|null}
         */
        $clean(field) {
            return this.$formCtrl.determine('$clean', field);
        },

        /**
         * Is the form or a field touched
         * @param {string} [field] optional field, else if all fields are touched
         * @return {boolean|null}
         */
        $touched(field) {
            return this.$formCtrl.determine('$touched', field);
        },

        /**
         * Is the form or a field touched
         * @param {string} [field] optional field, else if all fields are touched
         * @return {boolean|null}
         */
        $untouched(field) {
            return this.$formCtrl.determine('$untouched', field);
        },

        /**
         * Is the form or has an error. Error is touched and invalid
         *
         * @param {string} [field] optional field, else if all fields are in error
         * @return {boolean|null}
         */
        $error(field) {
            return this.$formCtrl.determine('$error', field);
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/form/validator/mixin.js